import { useMutation, useQuery } from 'react-query'
import {
  apiGetStations,
  apiGetComponentStationMappings,
  apiPostBulkStationAdjustments,
  apiResetStationAdjustments,
} from '../api/stations'

export const STATIONS_KEY = 'stations'

export const COMPONENT_STATION_MAPPINGS_KEY = 'component-station-mappings'

export const useComponentStationMappings = ({
  componentAlias,
  makeModelId,
  plantName,
}) => {
  const {
    data: mappings,
    isLoading,
    isFetching,
  } = useQuery(
    [COMPONENT_STATION_MAPPINGS_KEY, componentAlias, makeModelId, plantName],
    async () => {
      const result = await apiGetComponentStationMappings({
        componentAlias,
        makeModelId,
        plantName,
      })
      return result.data
    },
    {
      enabled: !!componentAlias && !!makeModelId && !!plantName,
      refetchOnWindowFocus: false,
    },
  )
  return { mappings, isLoading, isFetching }
}

export const useStations = ({ plant_name, make_model_id }) => {
  const {
    status,
    data: stations,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [STATIONS_KEY, plant_name, make_model_id],
    async () => {
      const result = await apiGetStations({ plant_name, make_model_id })
      return result.data
    },
    {
      refetchOnWindowFocus: true,
      enabled: !!plant_name,
    },
  )
  return {
    status,
    stations,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export const useBulkUpdateAssignedStations = () => {
  return useMutation(
    ({ componentAlias, plantName, makeModelId, assignments }) =>
      apiPostBulkStationAdjustments({
        component_alias: componentAlias,
        plant_name: plantName,
        make_model_id: makeModelId,
        assignments: assignments,
      }),
    {
      onSuccess: () => {},
    },
  )
}

export const useResetStationAdjustments = () => {
  return useMutation(
    ({ componentAlias, plantName, makeModelId }) =>
      apiResetStationAdjustments({
        component_alias: componentAlias,
        plant_name: plantName,
        make_model_id: makeModelId,
      }),
    {
      onSuccess: () => {},
    },
  )
}
